module.exports = __webpack_public_path__ + "img/logo.8d4625b1.png";